import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { RoleService } from 'src/app/core/services/role.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';

@Component({
  selector: 'filter-log-cases',
  templateUrl: './filter-log-cases.component.html',
  styleUrls: ['./filter-log-cases.component.scss'],
})
export class FilterLogCasesComponent implements OnInit {
  @Input() open;
  @Input() users;
  @Output() count = new EventEmitter();

  // public riskLevels = riskLevels;
  date = new Date();

  states = [
    {
      value: 'initial',
      name: 'Sin comenzar',
    },
    {
      value: 'running',
      name: 'En ejecución',
    },
    {
      value: 'tobeApproved',
      name: 'Por aprobar',
    },
    { value: 'archived', name: 'Archivado' },
    {
      value: 'toFinalize',
      name: 'Por finalizar',
    },
  ];
  today = { beging: new Date(), end: new Date() };
  yesterday = {
    beging: new Date(new Date().setDate(new Date().getDate() - 1)),
    end: new Date(),
  };
  last7Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date(),
  };
  last30Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 30)),
    end: new Date(),
  };
  dates = // ['Hoy', 'Ayer', 'Últimos 7 días', 'Últimos 30 días'];
    [
      {
        value: this.today,
        name: 'Hoy',
      },
      {
        value: this.yesterday,
        name: 'Ayer',
      },
      {
        value: this.last7Days,
        name: 'Últimos 7 días',
      },
      {
        value: this.last30Days,
        name: 'Últimos 30 días',
      },
    ];
  unitId;
  constructor(
    private readonly fb: FormBuilder,
    private readonly unitsService: UnitsService,
    private readonly route: ActivatedRoute, // private readonly casesService: CasesService
    private readonly userService: UserService,
    private readonly roleService: RoleService,
    private readonly casesService: CasesService
  ) {
    this.unitId = this.route.snapshot.paramMap.get('id');
  }
  form: FormGroup = this.fb.group({
    ip: [''],
    user: [''],
    role: [''],
    unit: [''],
    case_type: [''],
    status: [''],
    gai: [''],
    action: [''],
    start: [''],
    end: [''],
  });
  units = [];
  ngOnInit() {
    this.unitsService.allDataFilters().subscribe({
      next: (data) => {
        this.units = data;
        this.getRoles();
      },
    });
  }

  get getUnits() {
    return this.units.map((x) => x.unit);
  }
  unitsSelected = [];
  get caseTypes() {
    let caseTypes: ICaseType[] = [];
    let data = this.units.find((x) => x.unit._id == this.form.value.unit);
    if (data) caseTypes = [...caseTypes, ...data.cases];
    return caseTypes;
  }
  roles;
  getRoles() {
    this.roleService.getAll().subscribe((roles) => {
      this.roles = roles;
    });
  }
  // removeCasesByUnit() {
  //   this.form.value.unit = this.form.value.unit.filter((caseSelected) => {
  //     if (this.caseTypes.find((x) => x._id == caseSelected)) {
  //       return caseSelected;
  //     }
  //   });
  // }
  search() {
    this.casesService.filterRecordCases.next(this.form.value);
    let count = 0;
    for (let key in this.form.value) {
      if (
        this.form.value[key] != '' ||
        this.form.value[key] != 'null' ||
        this.form.value[key] != null
      ) {
        count += 1;
      }
    }
    this.count.emit(count);
  }
  cleanFilter() {
    this.form.reset();
    this.count.emit(0);
    this.casesService.filterRecordCases.next(this.form.value);
  }
}
